import { ApiKeyFetch } from 'api/fetchers/apiKey';
import BreadCrumbSegukids from 'components/BreadCrumbMex/BreadCrumbSegukids';
import { BaseButton } from 'components/InputsMex/inputs';
import Page from 'components/Page';
import { urlListAseguradoSKT } from 'constants/urls';
import useCustomToast from 'hooks/useCustomToasts';
import React, { useEffect, useState } from 'react';
import { PASOS_BREADCRUMBS } from 'utils/constants';
import COLORS from 'utils/constants/COLORS';
import PRODUCTOS from 'utils/constants/PRODUCTOS';
import Loading from 'wrappers/Loading';
import MessageMia from './MessageMia';
import ModalAsegurado from './ModalAsegurado';
import useQueryParams from 'hooks/useQueryParams';
import useCustomRouter from 'hooks/useCustomRouter';

const AseguradoKids = () => {
  
  const qParams = useQueryParams();
  const { idPoliza } = qParams;
  const history = useCustomRouter();

  const [loading, setLoading] = useState(false);

  const [asegurado, setAsegurado] = useState([]);

  const [nombres, setnombres] = useState();

  const { addWarningToast } = useCustomToast();

  const [pagador, setPagador] = useState();

  const getData = async () => {
    setLoading(true);
    const body = {
      idPoliza: idPoliza,
    };

    const res = await ApiKeyFetch.instance().post(urlListAseguradoSKT, body);
    if (res?.transaccion) {
      let asegurados = res.data.asegurado.asegurados;
      setAsegurado(asegurados);
      console.log(res.data);
      setnombres(res.data.nombreContratante?.split?.(' ')?.[0] || '');
      setPagador(res.data.pagadorAsContratante);
    }
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  const onClickAtras = () => {
    if (pagador) {
      history.push(`/kids/pagador?idPoliza=${idPoliza}&codProducto=SKT`);
    } else {
      history.push(`/kids/contratante?idPoliza=${idPoliza}&codProducto=SKT`);
    }
  };

  const verificarCompletado = () => {
    let completados = asegurado.reduce((contador, item) => contador + (item.completado ? 0 : 1), 0);
    if (completados === 0) {
      history.push(`/pago?idPoliza=${idPoliza}&codProducto=SKT`);
    } else {
      addWarningToast('Rellene todos los datos del asegurado');
    }
  };

  return (
    <Page>
      <BreadCrumbSegukids
        {...PASOS_BREADCRUMBS[PRODUCTOS.SEGUKIDS].breadCrumbPasosSegukids[6]}
        pasos={PASOS_BREADCRUMBS[PRODUCTOS.SEGUKIDS]?.pasosContratante}
        showImg={false}
        showImgTitle={true}
        subtitleClassnames={'col-md-12 p-0'}
      />

      <Loading loading={loading}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <MessageMia
                textMessage={
                  '!Gracias ' +
                  nombres +
                  '! por favor, revisa que la información de tu hijo o hijos es correcta y da click en continuar.'
                }
              ></MessageMia>
            </div>
          </div>
          <div className="border mb-5">
            <div className="row mt-2 mt-5">
              <div className="col-md-12">
                <h2 className="text-center text-mex">Información de los Asegurados hijos</h2>
              </div>
            </div>

            <div class="row mb-2 mt-4">
              <div class="col-lg-10 col-md-10 offset-md-1 offset-lg-1 col-sm-12">
                {asegurado &&
                  asegurado.map((item, index) => (
                    <div className="margin-30">
                      <div className="row align-items-center accordeon-kids">
                        <div className="col-10">
                          <span style={{ float: 'left', marginLeft: '30px' }}>
                            <h3> Asegurado hijo {index + 1}</h3>
                          </span>
                        </div>
                        <div className="col-2">
                          {!item.datos.datosCompletos && (
                            <ModalAsegurado child={item.datos.numAsegurado} data={item}></ModalAsegurado>
                          )}
                        </div>
                      </div>
                      {item.datos.datosCompletos && (
                        <div className="row accordion-item-body">
                          <div className="col-md-12">
                            <h3 className="mb-4 mt-5  text-mex">Datos de asegurado</h3>
                          </div>
                          <div className="col-md-6 ">
                            <div>
                              Nombre:
                              <span className="text-title">{item.datos?.nombres}</span>
                            </div>
                            <div>
                              Apellido Materno:
                              <span className="text-title">{item.datos?.apellidoMaterno}</span>
                            </div>
                            <div>
                              Fecha de Nacimiento:
                              <span className="text-title">{item.datos?.fechaNacimiento}</span>
                            </div>
                          </div>
                          <div className="col-md-6 ">
                            <div className="">
                              Apellido Paterno:
                              <span className="text-title">{item.datos?.apellidoPaterno}</span>
                            </div>
                            <div>
                              Sexo:
                              <span className="text-title">{item.datos?.sexo?.label}</span>
                            </div>
                          </div>
                          <div>
                            {item.datos.datosCompletos && (
                              <ModalAsegurado child={item.datos.numAsegurado} data={item} edit={true}></ModalAsegurado>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
              </div>
            </div>
            <div className="row justify-content-center mb-5">
              <div className="col-md-3">
                <BaseButton onClick={onClickAtras} type="button" textColor="white" bgColor={COLORS.primary}>
                  <i
                    className="pi pi-arrow-left"
                    style={{
                      position: 'relative',
                      top: '1px',
                      fontSize: '1.4rem',
                    }}
                  />{' '}
                  Atrás
                </BaseButton>
              </div>
              <div className="col-md-3 ">
                <BaseButton onClick={verificarCompletado} type="button" textColor="white" bgColor={COLORS.primary}>
                  Continuar{' '}
                  <i
                    className="pi pi-arrow-right"
                    style={{
                      position: 'relative',
                      top: '1px',
                      fontSize: '1.4rem',
                    }}
                  />
                </BaseButton>
              </div>
            </div>
          </div>
        </div>
      </Loading>
    </Page>
  );
};

export default AseguradoKids;
